/*
 * tbb-wish-heart.js - the wishlist heart on the product gallery.
 *
 * WHAT THIS IS
 * Desi, 2026-09-25: the "Add to Wishlist" text button was one of four stacked
 * buttons under the price. It becomes a solid pixel-art heart pinned to the
 * top-right corner of the product image, a secondary CTA icon, and the text
 * button goes away.
 *
 * HOW IT WORKS (no new backend, no app settings)
 * The wishlist is Auction Plus's <product-follow-button> app block, a Vue
 * component we do not control. We do not rebuild it: the app's block stays in
 * the page but hidden, the heart forwards every tap to the app's own button,
 * and a MutationObserver mirrors the app's state back onto the heart (outline
 * white = not saved, pink = saved). Guests get the app's own "Members Only"
 * toast exactly as before, because it is the same button.
 *
 * FAIL SAFE
 * If the app block is missing (app removed, block deleted in the editor, page
 * without it), nothing is hidden and nothing is drawn: the page is exactly what
 * the theme rendered. The hide rule keys on a class this file adds, never on
 * the app's markup alone.
 *
 * The heart is the Pixelarticons "heart" (MIT, https://pixelarticons.com), the
 * same set as the phone / web / mail icons in DESIGN_SYSTEM 3.9, filled solid.
 * Its edge takes the section's shell token (--tbb-border-color) so it follows
 * the PDP colour preset. (theme, 2026-09-25)
 */
(function () {
  'use strict';

  // Pixelarticons heart, outer boundary only, filled with currentColor.
  var HEART_PATH = 'M9 2H5v2H3v2H1v6h2v2h2v2h2v2h2v2h2v2h2v-2h2v-2h2v-2h2v-2h2v-2h2V6h-2V4h-2V2h-4v2h-2v2h-2V4H9V2z';
  var STAGE = '.\\#product-gallery-stage-inner';
  var LABEL_ON = 'Remove from Wishlist';
  var LABEL_OFF = 'Add to Wishlist';

  function mount() {
    var stage = document.querySelector('#MainContent ' + STAGE);
    var app = document.querySelector('#MainContent product-follow-button');
    var appBtn = app && app.querySelector('button');
    if (!stage || !appBtn || stage.querySelector('.tbb-wish-heart')) return;

    var heart = document.createElement('button');
    heart.type = 'button';
    heart.className = 'tbb-wish-heart';
    heart.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="' + HEART_PATH + '"/></svg>';

    function sync() {
      // The app's own label is the source of truth for saved / not saved.
      var on = /remove/i.test(appBtn.textContent || '');
      heart.classList.toggle('is-on', on);
      heart.setAttribute('aria-pressed', on ? 'true' : 'false');
      heart.setAttribute('aria-label', on ? LABEL_ON : LABEL_OFF);
    }
    new MutationObserver(sync).observe(app, { subtree: true, childList: true, characterData: true, attributes: true });
    heart.addEventListener('click', function () { appBtn.click(); });

    sync();
    stage.appendChild(heart);
    document.documentElement.classList.add('tbb-has-wish-heart'); // the CSS hides the app's text button only now
  }

  // Auction Plus renders its button client-side; wait for it (up to ~10s).
  function whenReady(tries) {
    var appBtn = document.querySelector('#MainContent product-follow-button button');
    if (appBtn) return mount();
    if (tries > 20) return;
    setTimeout(function () { whenReady(tries + 1); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { whenReady(0); });
  else whenReady(0);
})();
